/** 登录弹窗样式配置（输入框高度等在此调节） */
export const LoginModalConfig = {
  /** 输入框高度，单位 px */
  inputHeightPx: 48,
  /** Logo + 标题行：上 / 下内边距（px） */
  logoRowPaddingTopPx: 30,
  logoRowPaddingBottomPx: 30,
  /** 登录弹窗外层圆角（px） */
  borderRadiusPx: 15,
  /** 买家站主色（绿色） */
  primaryColor: '#00BF58',
  primaryColorLight: '#00D566',
} as const;
